import React from 'react';
import { List } from 'immutable';

import {
  Paragraph,
  View,
} from '@uncinc/react-drupal-core';

import {
  Container,
  WysiwygField,
  Image,
} from '@uncinc/uncinc-react-kitchen-sink';

import './style.scss';

const TaxonomyMaterialTypeDetail = ({ entity }) => {
  const materialTypeId = entity.getIn(['tid', 0, 'value'], null);
  const title = entity.getIn(['name', 0, 'value'], '');
  const imagSrc = entity.getIn(['field_hero_image', 0, 'styles', 'medium']);
  const body = entity.getIn(['description', 0, 'processed']);

  return (
    <article className="TaxonomyMaterialType">
      <Container>
        <div className="row">
          <div className="col-12">
            <div className="TaxonomyMaterialType__header">
              <div className="TaxonomyMaterialType__header__inner">
                <Image
                  lazyload={false}
                  className="TaxonomyMaterialType__image"
                  src={imagSrc}
                />
                <div className="TaxonomyMaterialType__body__wrapper">
                  <h1 className="TaxonomyMaterialType__title">{title}</h1>
                  <WysiwygField
                    property="schema:text"
                    html={body}
                    className="TaxonomyMaterialType__body"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Container>

      {entity.get('field_paragraphs') ? (
        <div className="TaxonomyMaterialType__paragraphs">
          {entity.get('field_paragraphs', List()).map((paragraph) => {
            const id = paragraph.get('target_id');
            const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
            return (
              <div key={`paragraph:${id}:${language}`} id={id} className="ParagraphAnchorWrapper">
                <Paragraph
                  key={`paragraph:${id}`}
                  id={id}
                  entity={paragraph.get('entity')}
                />
              </div>
            );
          })}
        </div>
      ) : null}

      <Container className="NodeArticleDetail__recent__articles">
        <div className="row">
          <div className="col-12">
            <View id="recent_articles" display="block_1" args={[materialTypeId, null]} />
          </div>
        </div>
      </Container>

    </article>
  );
};

export default TaxonomyMaterialTypeDetail;
